import * as Sentry from "@sentry/react";
import { cn } from "@/shared/lib/utils";
import { Button } from "@/shared/components/ui/button";

interface UserFeedbackButtonProps {
  /** Button-Text */
  label?: string;
  /** Zusätzliche CSS-Klassen für den Button */
  className?: string;
  /** Placeholder-Text im Feedback-Formular */
  messagePlaceholder?: string;
  /** Titel des Feedback-Formulars */
  formTitle?: string;
  /** Submit-Button-Text */
  submitLabel?: string;
  /** Erfolgs-Nachricht nach dem Absenden */
  successMessage?: string;
  /** Name- und Email-Felder anzeigen? */
  showName?: boolean;
  showEmail?: boolean;
  /** Optionale Tags für Routing/Filtering in Sentry */
  tags?: Record<string, string>;
}

export function UserFeedbackButton({
  label = "Feedback",
  className,
  messagePlaceholder = "Was ist passiert? Was hast Sie erwartet?",
  formTitle = "Feedback senden",
  submitLabel = "Absenden",
  successMessage = "Danke für Ihr Feedback!",
  showName = true,
  showEmail = true,
  tags,
}: UserFeedbackButtonProps) {
  if (import.meta.env.VITE_SENTRY_USER_FEEDBACK !== "true") {
    return null;
  }

  const feedback = Sentry.getFeedback();
  const handleClick = async () => {
    if (!feedback) {
      return;
    }

    const form = await feedback.createForm({
      formTitle,
      submitButtonLabel: submitLabel,
      successMessageText: successMessage,
      messagePlaceholder,
      showName,
      showEmail,
      ...(tags ? { tags } : {}),
    });

    form.appendToDom();
    form.open();
  };

  if (!feedback) {
    return null;
  }

  return (
    <Button
      variant="outline"
      type="button"
      onClick={handleClick}
      className={cn(className)}
    >
      {label}
    </Button>
  );
}
